{
  "name": "@looker-bi-gym/app",
  "version": "0.1.0",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite --config configs/vite.config.ts --host 127.0.0.1",
    "content:generate": "bun run scripts/generate-content-catalog.ts",
    "content:check": "bun run scripts/generate-content-catalog.ts --check",
    "build": "bun run content:generate && bun run validate:manifests && bun run validate:datasets && bun run typecheck && vite build --config configs/vite.config.ts",
    "check": "bun run format:check && bun run content:generate && bun run content:check && bun run validate:manifests && bun run validate:terminology && bun run validate:quiz-distractors && bun run validate:compartmentalization && bun run lint && bun run typecheck && bun run validate:datasets && bun run test:quiz && bun run test:sql && bun run test:fixtures && bun run test:derived-expectations && bun run test:cloud-evidence && bun run test:browser-config && bun run test:progress-export && bun run test:flashcards && bun run test:quiz-facts-db && bun run test:content-qa && bun run test:facts-db && bun run test:llm-workbench && bun run test:platform-boundary && bun run test:validators && bun run test:e2e && vite build --config configs/vite.config.ts && bun run validate:static-links",
    "lint": "bun run content:generate && bun run validate:manifests && eslint --config configs/eslint.config.ts . --max-warnings 0",
    "format": "prettier --write .. --ignore-path ../.prettierignore",
    "format:check": "prettier --check .. --ignore-path ../.prettierignore",
    "test:quiz": "bun run scripts/test-quiz.ts",
    "test:sql": "bun run scripts/test-sql.ts",
    "test:fixtures": "bun run scripts/test-solution-fixtures.ts",
    "test:derived-expectations": "bun run scripts/test-derived-expectations.ts",
    "test:cloud-evidence": "bun run scripts/test-cloud-evidence.ts",
    "test:browser-config": "bun run scripts/test-browser-config.ts",
    "test:progress-export": "bun run scripts/test-progress-export.ts",
    "test:flashcards": "bun run content:generate && bun run scripts/test-flashcards.ts",
    "test:quiz-facts-db": "bun run content:generate && bun run scripts/test-quiz-facts-db.ts",
    "test:content-qa": "bun run content:generate && bun run scripts/test-content-qa.ts",
    "test:facts-db": "bun run --filter facts-db-app test",
    "test:llm-workbench": "bun run scripts/test-llm-question-workbench.ts",
    "sources:snapshot": "bun run scripts/snapshot-source-materials.ts",
    "facts:build-db": "bun run --filter facts-db-app build-db",
    "questions:context": "bun run scripts/llm-question-workbench.ts context",
    "questions:generate:codex": "bun run scripts/llm-question-workbench.ts generate codex",
    "questions:generate:claude": "bun run scripts/llm-question-workbench.ts generate claude",
    "questions:review:codex": "bun run scripts/llm-question-workbench.ts review codex",
    "questions:review:claude": "bun run scripts/llm-question-workbench.ts review claude",
    "dream:prompt": "bun run scripts/llm-question-workbench.ts dream-prompt none",
    "dream:codex": "bun run scripts/llm-question-workbench.ts dream codex",
    "dream:claude": "bun run scripts/llm-question-workbench.ts dream claude",
    "test:platform-boundary": "bun run scripts/test-platform-boundary.ts",
    "test:e2e": "bun run scripts/test-e2e.ts",
    "verify:deployed-surface": "bun run scripts/verify-deployed-learning-surface.ts",
    "test:validators": "bun run scripts/test-validators.ts",
    "validate:datasets": "bun run scripts/validate-datasets.ts",
    "validate:manifests": "bun run scripts/validate-challenge-manifests.ts",
    "validate:static-links": "bun run scripts/validate-static-links.ts",
    "validate:terminology": "bun run scripts/validate-terminology.ts",
    "validate:quiz-distractors": "bun run scripts/validate-quiz-distractor-quality.ts",
    "validate:compartmentalization": "bun run scripts/validate-assessment-compartmentalization.ts",
    "coverage:terminology": "bun run scripts/generate-terminology-coverage.ts",
    "coverage:cert-track": "bun run scripts/generate-cert-track-coverage.ts",
    "typecheck": "bun run content:generate && bun run validate:manifests && tsc -p tsconfig.json --noEmit --pretty false && tsc -p tsconfig.node.json --noEmit --pretty false",
    "preview": "vite preview --config configs/vite.config.ts --host 127.0.0.1"
  },
  "dependencies": {
    "@duckdb/duckdb-wasm": "1.29.1-dev132.0",
    "marked": "18.0.3",
    "react": "19.2.5",
    "react-dom": "19.2.5",
    "yaml": "2.8.4"
  },
  "devDependencies": {
    "@eslint/js": "10.0.1",
    "@playwright/test": "1.57.0",
    "@types/node": "25.6.0",
    "@types/react": "19.2.14",
    "@types/react-dom": "19.2.3",
    "@vitejs/plugin-react": "6.0.1",
    "ajv": "8.20.0",
    "eslint": "10.3.0",
    "eslint-plugin-react-hooks": "7.1.1",
    "eslint-plugin-react-refresh": "0.5.2",
    "facts-db-app": "workspace:*",
    "globals": "17.6.0",
    "jiti": "2.7.0",
    "prettier": "3.8.3",
    "typescript": "6.0.3",
    "typescript-eslint": "8.59.2",
    "vite": "8.0.10"
  }
}
